import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="cloud" maskId="round-filled-radius-1-stroke-1.5-IconCloud"><path d="M12 4C9.20241 4 6.80396 5.70153 5.77996 8.12427C3.05102 8.68825 1 11.1041 1 14C1 17.3137 3.68629 20 7 20H18.125C20.8174 20 23 17.8174 23 15.125C23 12.639 21.1392 10.5876 18.7344 10.2877C18.4969 6.77542 15.5725 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloud;
